import React from 'react';
import './QuoteTestimonials.css';

export const QUOTE_TESTIMONIALS = [
  {
    name: 'Johan',
    quote:
      'Løpeglad appen har gitt meg tilbake troen på at jeg kan være en løper og bidratt til å gi meg glede ved løping.',
    avatar: '/img/testimonials/johan.png'
  },
  {
    name: 'Marit',
    quote:
      'Jeg har fått en bedre teknikk ved hjelp av appen, og på den måten kan jeg få til å løpe lengre. Liker godt å ha stemmen og påminnelser på øret om hvor fokus skal være.',
    avatar: '/img/testimonials/marit.png'
  },
  {
    name: 'Maja',
    quote:
      'Fader den 45/15 økta funka! Jeg var helt oppe i 12km/t på flere drag og det kjentes helt greit ut. Det har aldri skjedd før. Hadde god kontroll på pulsen også. Dette var gøy!',
    avatar: '/img/testimonials/maja.png'
  }
];

const QuoteTestimonials = ({
  title = 'Vanlige mennesker. Ekte løpeglede.',
  titleClassName = 'quote-testimonials__title',
  className = '',
  items = QUOTE_TESTIMONIALS
}) => {
  return (
    <div className={`quote-testimonials ${className}`.trim()}>
      {title ? <h2 className={titleClassName}>{title}</h2> : null}
      <div className="quote-testimonials__grid">
        {items.map((item) => (
          <article key={item.name} className="quote-testimonials__card">
            <div className="quote-testimonials__avatar">
              {item.avatar ? (
                <img src={item.avatar} alt="" loading="lazy" />
              ) : (
                <span>{item.name.charAt(0)}</span>
              )}
            </div>
            <div className="quote-testimonials__body">
              <p>
                <span className="quote-testimonials__mark" aria-hidden="true">
                  “
                </span>
                {item.quote}
              </p>
              <footer>{item.age ? `${item.name}, ${item.age} år` : item.name}</footer>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default QuoteTestimonials;
